import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { InquiryLabelsFormValues } from 'src/models/InquiryLabels.model';
import InquiryLabelsForm from '../Layouts/InquiryLabelsForm';
import { useAddInquiryLabelMutation } from 'src/services/InquiryLabelServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
    onClose: () => void;
};

const AddInquiryLabelsFormWrapper = ({ onClose }: Props) => {
    // Form Initial Values
    const initialValues: InquiryLabelsFormValues = {
        inquiryLabel: ''
    };
    // Validation Schema
    const validationSchema = object().shape({
        inquiryLabel: string().required('Please enter inquiry Label'),
    });

    const [AddInquiryLabel] = useAddInquiryLabelMutation()

    // Handle Submit
    const handleSubmit = (
        values: InquiryLabelsFormValues,
        { setSubmitting, resetForm }: FormikHelpers<InquiryLabelsFormValues>
    ) => {
        const formattedValues = {
            inquiryLabel: values?.inquiryLabel
        };

        AddInquiryLabel(formattedValues).then((res: any) => {
            if (res?.error) {
                showToast('error', res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast('success', res?.data?.message);
                    resetForm();
                    onClose();
                } else {
                    showToast('error', res?.data?.message);
                }
            }
            setSubmitting(false);
        })
       
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <InquiryLabelsForm formikProps={formikProps} onClose={onClose} formType='ADD' />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddInquiryLabelsFormWrapper;